import React from 'react';
import pt from './pt';

const LanguageContext = React.createContext({
  language: pt,
});

export default LanguageContext;
